var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialHours01 = function SvgSocialHours01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "social_hours-01_svg2__a",
    x1: 46.57,
    x2: 143.21,
    y1: 153.42,
    y2: 56.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#social_hours-01_svg2__a",
    id: "social_hours-01_svg2__b",
    x1: 27.32,
    x2: 123.97,
    y1: 134.18,
    y2: 37.53
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#social_hours-01_svg2__a",
    id: "social_hours-01_svg2__c",
    x1: -22.18,
    x2: 74.46,
    y1: 84.67,
    y2: -11.97
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#social_hours-01_svg2__a",
    id: "social_hours-01_svg2__d",
    x1: 70.56,
    x2: 167.2,
    y1: 177.41,
    y2: 80.77
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#social_hours-01_svg2__a",
    id: "social_hours-01_svg2__e",
    x1: 74.7,
    x2: 171.34,
    y1: 181.55,
    y2: 84.91
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#social_hours-01_svg2__a",
    id: "social_hours-01_svg2__f",
    x1: 42.4,
    x2: 139.04,
    y1: 149.25,
    y2: 52.61
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#social_hours-01_svg2__a",
    id: "social_hours-01_svg2__g",
    x1: 69.48,
    x2: 166.12,
    y1: 176.33,
    y2: 79.69,
    gradientTransform: "rotate(45 86.7 159.122)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#social_hours-01_svg2__a",
    id: "social_hours-01_svg2__h",
    x1: 96.56,
    x2: 193.2,
    y1: 203.41,
    y2: 106.77
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#social_hours-01_svg2__a",
    id: "social_hours-01_svg2__i",
    x1: 107.78,
    x2: 204.42,
    y1: 214.63,
    y2: 117.99,
    gradientTransform: "rotate(44.98 163.305 159.111)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#social_hours-01_svg2__a",
    id: "social_hours-01_svg2__j",
    x1: 96.57,
    x2: 193.21,
    y1: 203.42,
    y2: 106.78
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#social_hours-01_svg2__a",
    id: "social_hours-01_svg2__k",
    x1: 69.48,
    x2: 166.13,
    y1: 176.34,
    y2: 79.69,
    gradientTransform: "rotate(45.01 163.287 82.525)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M33.33 129.16h8.33v66.67h-8.33z",
    style: {
      fill: "url(#social_hours-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 124.99V79.16c0-13.79-11.21-25-25-25H25c-13.79 0-25 11.21-25 25v45.83c0 2.3 1.87 4.17 4.17 4.17h12.5v66.67H25V112.5h-8.33v8.33H8.34V79.16c0-9.19 7.48-16.67 16.67-16.67h25c9.19 0 16.67 7.48 16.67 16.67v41.67h-8.33v-8.33h-8.33v83.33h8.33v-66.67h12.5c2.3 0 4.17-1.86 4.17-4.17z",
    style: {
      fill: "url(#social_hours-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 45.83c11.49 0 20.83-9.35 20.83-20.83S48.99 4.17 37.5 4.17 16.67 13.52 16.67 25s9.35 20.83 20.83 20.83m0-33.33C44.39 12.5 50 18.11 50 25s-5.61 12.5-12.5 12.5S25 31.89 25 25s5.61-12.5 12.5-12.5",
    style: {
      fill: "url(#social_hours-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.99 45.83c-12.35 0-24.57 3.05-35.3 8.83a4.18 4.18 0 0 0-1.7 5.64 4.167 4.167 0 0 0 5.64 1.7c9.67-5.2 20.22-7.84 31.36-7.84 36.76 0 66.67 29.91 66.67 66.67s-29.91 66.67-66.67 66.67c-17.7 0-34.4-6.97-47.05-19.61a4.16 4.16 0 0 0-5.89 0 4.16 4.16 0 0 0 0 5.89C86.27 188 105.08 195.84 125 195.84c41.35 0 75-33.65 75-75s-33.65-75-75-75Z",
    style: {
      fill: "url(#social_hours-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.82 109.04c-4.85 1.72-8.33 6.35-8.33 11.78 0 6.89 5.61 12.5 12.5 12.5 1.93 0 3.75-.44 5.39-1.22l16.67 16.67c.81.81 1.88 1.22 2.95 1.22s2.13-.41 2.95-1.22a4.16 4.16 0 0 0 0-5.89l-16.67-16.67c.78-1.63 1.22-3.46 1.22-5.39 0-5.43-3.48-10.06-8.33-11.78V91.66c0-2.3-1.86-4.17-4.17-4.17s-4.17 1.87-4.17 4.17v17.38Zm4.17 7.62c2.3 0 4.17 1.87 4.17 4.17s-1.87 4.17-4.17 4.17-4.17-1.87-4.17-4.17 1.87-4.17 4.17-4.17",
    style: {
      fill: "url(#social_hours-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.82 62.5h8.33v8.33h-8.33z",
    style: {
      fill: "url(#social_hours-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.53 154.96h8.34v8.33h-8.34z",
    style: {
      fill: "url(#social_hours-01_svg2__g)"
    },
    transform: "rotate(-45 86.699 159.118)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.82 170.82h8.33v8.33h-8.33z",
    style: {
      fill: "url(#social_hours-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.13 154.95h8.33v8.33h-8.33z",
    style: {
      fill: "url(#social_hours-01_svg2__i)"
    },
    transform: "rotate(-44.98 163.296 159.11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.99 116.66h8.33v8.33h-8.33z",
    style: {
      fill: "url(#social_hours-01_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.13 78.36h8.33v8.33h-8.33z",
    style: {
      fill: "url(#social_hours-01_svg2__k)"
    },
    transform: "rotate(-45.01 163.295 82.53)"
  }));
};
export default SvgSocialHours01;